export const SUB_ITEM_LIST_TYPES = {
  CATEGORY_OVERVIEW: 'category-overview',
  SUB_CATEGORY_OVERVIEW: 'sub-category-overview',
}
